<template>
    <div class="footer relative" style="background:#1c1c1e; overflow:hidden;">
        <div class="b-container relative" style="z-index:2; padding-top:72px; padding-bottom:72px;">
            <div class="column section">
                <div class="column center mb-xl">
                    <div class="row">
                        <div class="h1 primary">联系我们</div>
                      
                    </div>
                    <div
                        class="t3 secondary"
                        style="text-transform: uppercase; letter-spacing:.1em; color:#666;"
                    >
                        Contact us
                    </div>
                    <div class="divider mt-xl"></div>
                </div>

                <div class="b-row py-xl">
                    <div class="col-12 col-lg-6 col-xl-6 column center count2 company-contact">
                        <div class="row mb-xl">
                            <div class="row v-center t4 mr-xxl white">
                                关注我们
                            </div>
                            <div class="row start v-center">
                                <div class="icon-44 mr-md">
                                    <div @click="toggleQrcode" class="social-media-item">
                                        <i class="iconfont icon-wechat"></i>
                                    </div>
                                </div>
                                <!-- <div class="icon-44" style="border-radius:50%; background:#2c2c2e;">
                                    <a
                                        href="https://weibo.com"
                                        target="_blank"
                                        class="social-media-item"
                                        ><i class="iconfont icon-weibo"></i
                                    ></a>
                                </div> -->
                            </div>
                        </div>

                        <div class="py-lg pr-lg t5 secondary mb-xl" style="line-height:1.8;">
                            联系电话：400-882-7002<br />
                            品牌合作：tutuan888@yeah.net<br />
                            运营商合作：tutuan888@yeah.net<br />
                            供应链合作：tutuan888@yeah.net<br />
                            公司地址：浙江省杭州市余杭区博园路1号
                        </div>
                    </div>
                   <div class="col-12 col-lg-6 col-xl-6">
                        <div class="company-address">
                            <video
                                src=""
                                style="width:100%; height:100%; border-radius:0;"
                                width="900"
                                height="600"
                            />
                        </div>
                    </div>
                </div>

                <div class="mt-xl t6 copyright">
                    <span class="mr-lg">
                        © 2023 喜礼季 版权所有
                    </span>
                    <span>
                        <a href="http://beian.miit.gov.cn" target="_blank" class="link"
                            >浙ICP备2023028455号</a
                        >
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CompanyAddress, PlusRedIcon, ContactBg } from '@/constants/pics';

export default {
    name: 'contact',

    components: {},

    props: ['toggleQrcode'],

    data() {
        return {
            CompanyAddress,
            PlusRedIcon,
            ContactBg,
        };
    },

    computed: {},

    created() {},

    mounted() {},

    activated() {},

    deactivated() {},

    methods: {},
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.contact-wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
}
.contact-wrap.display {
    display: block;
}
.contact-wrap.hide {
    display: none;
}

.contact-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.62);
    z-index: 98;
}

.divider {
    position: relative;
    height: 3px;
}
.divider:after {
    content: '';
    position: absolute;
    left: 0;
    opacity: 1;
    top: 0;
    width: 24px;
    height: 3px;
    border-radius: 2px;
    background: #ff3355;
}

.social-media-item {
    text-decoration: none;
    cursor: pointer;
}

.social-media-item i {
    color: #fff;
    font-size: 32px;
}

.footer a.social-media i {
    color: #666;
}
.footer a:hover.social-media i {
    color: #999;
}

.footer a.link {
    color: #666;
    text-decoration: none;
}
.footer a:hover.link {
    color: #999;
    text-decoration: none;
}

.copyright {
    color: #666;
}

@media (max-width: 991px) {
    .h1 {
        font-size: 24px;
    }
}
</style>
